import React, { useMemo, useState } from 'react'
import { Row, Col, Card, Table, Input, Tag, Button, Typography, Modal, Space, Avatar } from 'antd'
import { SearchOutlined, BankOutlined, CloseOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

//const BUILD_LANG = 'lotin' // 'lotin' | 'kiril' — flip this and rebuild for the Cyrillic bundle
const BUILD_LANG = 'kiril' // 'lotin' | 'kiril' — flip this and rebuild for the Cyrillic bundle

// Design tokens shared across the whole app (mirrors the original HTML mockups)
const colors = {
    navy: '#1B3A5C',
    navyDark: '#0F2236',
    navyMid: '#243D5A',
    amber: '#E8A020',
    amberBg: '#FFF8EC',
    amberBorder: '#F5D48A',
    green: '#1E8449',
    greenBg: '#EAF5EE',
    greenBorder: '#A9DDB8',
    red: '#C0392B',
    redBg: '#FDECEA',
    redBorder: '#F1A9A0',
    yellow: '#D4AC0D',
    yellowBg: '#FDF6E3',
    yellowBorder: '#F0D066',
    blue: '#2471A3',
    blueBg: '#EBF5FB',
    blueBorder: '#AED6F1',
    purple: '#6C3483',
    purpleBg: '#F4ECF7',
    purpleBorder: '#C39BD3',
    teal: '#117A65',
    tealBg: '#E8F8F5',
    tealBorder: '#76D7C4',
    orange: '#D35400',
    orangeBg: '#FEF0E7',
    white: '#FFFFFF',
    bg: '#F4F6FA',
    border: '#DDE3EA',
    gray: '#7A8899',
    gray2: '#95A5A6',
    dark: '#1E2A38',
}


const recentBankIncome = [
    { key: '1', time: '14:32', amount: '350,000', account: '101-25-000147-8', inmate: 'Тошматов Ж.А.', facility: 'MTX-1', status: { type: 'green', label: '✓ Автоматик' } },
    { key: '2', time: '14:18', amount: '200,000', account: '102-25-000089-4', inmate: 'Каримов Ш.У.', facility: '51-MK', status: { type: 'yellow', label: '⚠ Тасдиклаш' } },
    { key: '3', time: '13:55', amount: '500,000', account: '—', inmate: 'Аникланмаган', facility: '10-JIEK', status: { type: 'red', label: "✗ Кулда" } },
    { key: '4', time: '13:40', amount: '1,200,000', account: '101-25-000231-2', inmate: 'Рахматуллаев Б.', facility: '10-TH', status: { type: 'green', label: '✓ Автоматик' } },
    { key: '5', time: '13:12', amount: '75,000', account: '103-25-000011-6', inmate: 'Назаров О.Т.', facility: '36-MK', status: { type: 'green', label: '✓ Автоматик' } },
    { key: '6', time: '12:48', amount: '900,000', account: '—', inmate: 'Аникланмаган', facility: "2-TH", status: { type: 'red', label: "✗ Кулда" } },
    { key: '7', time: '12:20', amount: '450,000', account: '104-25-000055-9', inmate: 'Холматов А.К.', facility: "27-MK", status: { type: 'yellow', label: '⚠ Тасдиклаш' } },
]

const DASHBOARD_TEXT = [
    { key: 'pageTitle', lotin: 'Bosh Sahifa', kiril: 'Бош Саҳифа' },
    { key: 'pageSubtitle', lotin: "Bugungi moliyaviy ko'rsatkichlar va faoliyat xulosasi", kiril: 'Бугунги молиявий кўрсаткичлар ва фаолият хулосаси' },
    { key: 'statLabel1', lotin: 'Bugungi Kirimlar', kiril: 'Бугунги Киримлар' },
    { key: 'statLabel2', lotin: 'Tasdiqlash Kerak', kiril: 'Тасдиқлаш Керак' },
    { key: 'statLabel3', lotin: 'Hal Qilinmagan', kiril: 'Ҳал Қилинмаган' },
    { key: 'statLabel4', lotin: 'Faol Mahkumlar', kiril: 'Фаол Маҳкумлар' },
    { key: 'statValue1', lotin: "24,750,000 so'm", kiril: '24,750,000 сўм' },
    { key: 'statValue2', lotin: '18 ta', kiril: '18 та' },
    { key: 'statValue3', lotin: '5 ta', kiril: '5 та' },
    { key: 'statValue4', lotin: '1,247 ta', kiril: '1,247 та' },
    { key: 'statChange1', lotin: '↑ +127 ta tranzaksiya', kiril: '↑ +127 та транзакция' },
    { key: 'statChange2', lotin: "Sariq ro'yxat", kiril: 'Сариқ рўйхат' },
    { key: 'statChange3', lotin: "Qizil ro'yxat", kiril: 'Қизил рўйхат' },
    { key: 'statChange4', lotin: "3 ta bugun qo'shildi", kiril: '3 та бугун қўшилди' },
    { key: 'chartTitle', lotin: "Bank Kirimlar — So'nggi 12 soat", kiril: 'Банк Киримлар — Сўнгги 12 соат' },
    { key: 'liveTag', lotin: '● Jonli', kiril: '● Жонли' },
    { key: 'legendAuto', lotin: 'Avtomatik', kiril: 'Автоматик' },
    { key: 'legendYellow', lotin: 'Sariq', kiril: 'Сариқ' },
    { key: 'legendRed', lotin: 'Qizil', kiril: 'Қизил' },
    { key: 'detectionTitle', lotin: 'Aniqlash Holati', kiril: 'Аниқлаш Ҳолати' },
    { key: 'legendAutoPct', lotin: 'Avtomatik — 76%', kiril: 'Автоматик — 76%' },
    { key: 'legendYellowPct', lotin: 'Sariq — 16%', kiril: 'Сариқ — 16%' },
    { key: 'legendRedPct', lotin: 'Qizil — 8%', kiril: 'Қизил — 8%' },
    { key: 'pending', lotin: 'Kutilmoqda', kiril: 'Кутилмоқда' },
    { key: 'recentTitle', lotin: "So'nggi Bank Kirimlar", kiril: 'Сўнгги Банк Киримлар' },
    { key: 'searchPlaceholder', lotin: 'Qidirish...', kiril: 'Қидириш...' },
    { key: 'viewAll', lotin: "Barchasini ko'rish →", kiril: 'Барчасини кўриш →' },
    { key: 'colTime', lotin: 'Vaqt', kiril: 'Вақт' },
    { key: 'colAmount', lotin: 'Summa', kiril: 'Сумма' },
    { key: 'colAccount', lotin: 'Hisob Raqam', kiril: 'Ҳисоб Рақам' },
    { key: 'colInmate', lotin: 'Mahkum', kiril: 'Маҳкум' },
    { key: 'colFacility', lotin: 'Muassasa', kiril: 'Муассаса' },
    { key: 'colStatus', lotin: 'Holat', kiril: 'Ҳолат' },
    { key: 'colAction', lotin: 'Harakat', kiril: 'Ҳаракат' },
    { key: 'viewBtn', lotin: "Ko'rish", kiril: 'Кўриш' },
    { key: 'bankIncomeLabel', lotin: 'Bank Kirimi', kiril: 'Банк Кирими' },
    { key: 'closeBtn', lotin: 'Yopish', kiril: 'Ёпиш' },
    { key: 'goToProfileBtn', lotin: "Mahkum profiliga o'tish", kiril: 'Маҳкум профилига ўтиш' },
    { key: 'syncTag', lotin: 'Bank sinxron: 4 daqiqa oldin', kiril: 'Банк синхрон: 4 дақиқа олдин' },
    { key: 'dateTag', lotin: '25-May, 2025', kiril: '2025 йил, 25 май' },
]

// Array of {key, lotin, kiril} -> lookup map, so components just call t(key).
const TEXT_MAP = Object.fromEntries(DASHBOARD_TEXT.map((row) => [row.key, row]))

const BREADCRUMB_KEY = 'pageTitle'

function buildStatCards(t) {
    return [
        { color: colors.green, icon: '💰', value: t('statValue1'), label: t('statLabel1'), change: t('statChange1'), changeColor: colors.green },
        { color: colors.amber, icon: '⚠️', value: t('statValue2'), label: t('statLabel2'), change: t('statChange2'), changeColor: colors.amber },
        { color: colors.red, icon: '🔴', value: t('statValue3'), label: t('statLabel3'), change: t('statChange3'), changeColor: colors.red },
        { color: colors.blue, icon: '👥', value: t('statValue4'), label: t('statLabel4'), change: t('statChange4'), changeColor: colors.blue },
    ]
}

const hourlyBars = [
    { t: '02:00', g: 30, y: 8, r: 3 },
    { t: '04:00', g: 18, y: 5, r: 0 },
    { t: '06:00', g: 24, y: 7, r: 2 },
    { t: '08:00', g: 55, y: 12, r: 5 },
    { t: '10:00', g: 75, y: 18, r: 7 },
    { t: '12:00', g: 90, y: 20, r: 8 },
    { t: '14:00', g: 68, y: 15, r: 4 },
    { t: '16:00', g: 80, y: 14, r: 6 },
    { t: '18:00', g: 45, y: 10, r: 3 },
    { t: '20:00', g: 32, y: 8, r: 0 },
    { t: '22:00', g: 20, y: 4, r: 0 },
    { t: '00:00', g: 15, y: 5, r: 2 },
]

const statusColors = { green: colors.green, yellow: colors.yellow, red: colors.red }
const statusBg = { green: colors.greenBg, yellow: colors.yellowBg, red: colors.redBg }

function StatusBadge({ status, children }) {
    return (
        <Tag style={{ background: statusBg[status], color: status === 'yellow' ? '#8a6d00' : statusColors[status], border: 'none', borderRadius: 20, fontWeight: 600 }}>
            {children}
        </Tag>
    )
}

// Detail card shown inside the "Ko'rish" modal — mirrors the app's card language
// (status tag, mono account number, amber accent) instead of a plain data dump.
// Takes `t` as a prop since it's a sibling component, not a hook consumer.
function TransactionDetailCard({ record, onClose, t }) {
    if (!record) return null
    const tone = { green: colors.green, yellow: '#8a6d00', red: colors.red }[record.status.type]
    const toneBg = { green: colors.greenBg, yellow: colors.yellowBg, red: colors.redBg }[record.status.type]

    return (
        <div style={{ borderRadius: 16, overflow: 'hidden', border: `1px solid ${colors.border}` }}>
            <div
                style={{
                    background: `linear-gradient(135deg, ${colors.navyDark} 0%, #1a3a5e 100%)`,
                    padding: '20px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 16,
                }}
            >
                <Avatar size={48} style={{ background: colors.amber, color: colors.navyDark, fontWeight: 700, flexShrink: 0 }} icon={<BankOutlined />} />
                <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', marginBottom: 3 }}>{t('bankIncomeLabel')}</div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#fff' }}>{record.amount}</div>
                </div>
                <Tag style={{ background: toneBg, color: tone, border: 'none', borderRadius: 20, fontWeight: 600 }}>{record.status.label}</Tag>
            </div>

            <div style={{ padding: 20 }}>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <div style={{ fontSize: 11, color: colors.gray, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 3 }}>{t('colTime')}</div>
                        <div style={{ fontSize: 14, fontWeight: 500 }}>{record.time}</div>
                    </Col>
                    <Col span={12}>
                        <div style={{ fontSize: 11, color: colors.gray, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 3 }}>{t('colAccount')}</div>
                        <div className="mono" style={{ fontSize: 14, fontWeight: 500, color: colors.blue }}>{record.account}</div>
                    </Col>
                    <Col span={12}>
                        <div style={{ fontSize: 11, color: colors.gray, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 3 }}>{t('colInmate')}</div>
                        <div style={{ fontSize: 14, fontWeight: 500 }}>{record.inmate}</div>
                    </Col>
                    <Col span={12}>
                        <div style={{ fontSize: 11, color: colors.gray, textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 3 }}>{t('colFacility')}</div>
                        <div style={{ fontSize: 14, fontWeight: 500 }}>{record.facility}</div>
                    </Col>
                </Row>

                <Space style={{ marginTop: 22, width: '100%', justifyContent: 'flex-end' }}>
                    <Button onClick={onClose}>{t('closeBtn')}</Button>
                    <Button type="primary">{t('goToProfileBtn')}</Button>
                </Space>
            </div>
        </div>
    )
}

export default function DashboardPage() {
    const [selectedTx, setSelectedTx] = useState(null)

    // See BUILD_LANG above — this is the one and only place the language is
    // picked for this build. Kept as state (not a plain const read) so a real
    // switcher can flip it later without restructuring the rest of the page.
    const [lang] = useState(BUILD_LANG)
    const t = (key) => TEXT_MAP[key]?.[lang] ?? key

    const statCards = useMemo(() => buildStatCards(t), [lang])

    const columns = [
        { title: t('colTime'), dataIndex: 'time', key: 'time' },
        { title: t('colAmount'), dataIndex: 'amount', key: 'amount', render: (v) => <Text strong>{v}</Text> },
        { title: t('colAccount'), dataIndex: 'account', key: 'account', render: (v) => <span className="mono" style={{ color: colors.blue, fontSize: 12 }}>{v}</span> },
        { title: t('colInmate'), dataIndex: 'inmate', key: 'inmate' },
        { title: t('colFacility'), dataIndex: 'facility', key: 'facility' },
        { title: t('colStatus'), dataIndex: 'status', key: 'status', render: (s) => <StatusBadge status={s.type}>{s.label}</StatusBadge> },
        { title: t('colAction'), key: 'action', render: (_, record) => <Button size="small" onClick={() => setSelectedTx(record)}>{t('viewBtn')}</Button> },
    ]

    const extra = useMemo(
        () => (
            <>
                <Tag style={{ background: colors.greenBg, border: `1px solid ${colors.greenBorder}`, color: colors.green, borderRadius: 6, padding: '4px 10px' }}>
                    {t('syncTag')}
                </Tag>
                <Tag style={{ background: colors.bg, border: `1px solid ${colors.border}`, color: colors.gray, borderRadius: 6, padding: '4px 10px' }}>{t('dateTag')}</Tag>
            </>
        ),
        [lang],
    )


    return (
        <>
            <Title level={3} style={{ marginBottom: 2 }}>{t('pageTitle')}</Title>
            <Text type="secondary">{t('pageSubtitle')}</Text>

            <Row gutter={14} style={{ margin: '20px 0 4px' }}>
                {statCards.map((s) => (
                    <Col span={6} key={s.label}>
                        <Card style={{ borderRadius: 14, borderTop: `3px solid ${s.color}`, position: 'relative' }} bodyStyle={{ padding: '18px 20px' }}>
                            <div style={{ fontSize: 22, marginBottom: 10 }}>{s.icon}</div>
                            <div style={{ fontSize: 22, fontWeight: 700, color: colors.dark, lineHeight: 1, marginBottom: 4 }}>{s.value}</div>
                            <div style={{ fontSize: 12, color: colors.gray, marginBottom: 6 }}>{s.label}</div>
                            <div style={{ fontSize: 11.5, color: s.changeColor }}>{s.change}</div>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Row gutter={14} style={{ margin: '18px 0' }}>
                <Col span={15}>
                    <Card
                        title={
                            <span>
                {t('chartTitle')}{' '}
                                <Tag style={{ background: colors.greenBg, color: colors.green, border: 'none', marginLeft: 6 }}>{t('liveTag')}</Tag>
              </span>
                        }
                        style={{ borderRadius: 14 }}
                    >
                        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: 100 }}>
                            {hourlyBars.map((b) => (
                                <div key={b.t} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flex: 1 }}>
                                    <div style={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
                                        <div style={{ width: 10, height: b.g, background: colors.green, borderRadius: '3px 3px 0 0' }} />
                                        <div style={{ width: 10, height: b.y, background: colors.yellow, borderRadius: '3px 3px 0 0' }} />
                                        {b.r > 0 && <div style={{ width: 10, height: b.r, background: colors.red, borderRadius: '3px 3px 0 0' }} />}
                                    </div>
                                    <div style={{ fontSize: 10, color: colors.gray }}>{b.t}</div>
                                </div>
                            ))}
                        </div>
                        <div style={{ display: 'flex', gap: 16, marginTop: 10 }}>
                            <span style={{ fontSize: 11, display: 'flex', alignItems: 'center', gap: 4, color: colors.gray }}><span style={{ width: 10, height: 10, background: colors.green, borderRadius: 2, display: 'inline-block' }} />{t('legendAuto')}</span>
                            <span style={{ fontSize: 11, display: 'flex', alignItems: 'center', gap: 4, color: colors.gray }}><span style={{ width: 10, height: 10, background: colors.yellow, borderRadius: 2, display: 'inline-block' }} />{t('legendYellow')}</span>
                            <span style={{ fontSize: 11, display: 'flex', alignItems: 'center', gap: 4, color: colors.gray }}><span style={{ width: 10, height: 10, background: colors.red, borderRadius: 2, display: 'inline-block' }} />{t('legendRed')}</span>
                        </div>
                    </Card>
                </Col>
                <Col span={9}>
                    <Card title={t('detectionTitle')} style={{ borderRadius: 14, height: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 18, marginTop: 8 }}>
                            <div
                                style={{
                                    width: 90,
                                    height: 90,
                                    borderRadius: '50%',
                                    flexShrink: 0,
                                    background: `conic-gradient(${colors.green} 0% 76%, ${colors.yellow} 76% 92%, ${colors.red} 92% 100%)`,
                                    position: 'relative',
                                }}
                            >
                                <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 58, height: 58, background: '#fff', borderRadius: '50%' }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: colors.green, display: 'inline-block' }} />{t('legendAutoPct')}</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: colors.yellow, display: 'inline-block' }} />{t('legendYellowPct')}</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12 }}><span style={{ width: 8, height: 8, borderRadius: '50%', background: colors.red, display: 'inline-block' }} />{t('legendRedPct')}</div>
                            </div>
                        </div>
                        <Row style={{ marginTop: 18, paddingTop: 14, borderTop: `1px solid ${colors.border}` }}>
                            <Col span={12} style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 18, fontWeight: 700, color: colors.green }}>342</div>
                                <div style={{ fontSize: 11, color: colors.gray }}>{t('legendAuto')}</div>
                            </Col>
                            <Col span={12} style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: 18, fontWeight: 700, color: colors.amber }}>74</div>
                                <div style={{ fontSize: 11, color: colors.gray }}>{t('pending')}</div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>

            <Card
                title={t('recentTitle')}
                extra={
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                        <Input placeholder={t('searchPlaceholder')} prefix={<SearchOutlined />} style={{ width: 200 }} />
                        <a style={{ fontSize: 13, color: colors.blue, fontWeight: 500 }}>{t('viewAll')}</a>
                    </div>
                }
                style={{ borderRadius: 14 }}
                bodyStyle={{ padding: 0 }}
            >
                <Table columns={columns} dataSource={recentBankIncome} pagination={false} rowKey="key" size="middle" />
            </Card>

            <Modal
                open={!!selectedTx}
                onCancel={() => setSelectedTx(null)}
                footer={null}
                closeIcon={<CloseOutlined style={{ color: '#fff' }} />}
                width={480}
                styles={{ content: { padding: 0, borderRadius: 16, overflow: 'hidden' }, body: { padding: 0 } }}
            >
                <TransactionDetailCard record={selectedTx} onClose={() => setSelectedTx(null)} t={t} />
            </Modal>
        </>
    )
}
